import React, { Fragment, useState, useEffect } from 'react';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { makeStyles } from '@mui/styles';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Box,
    Select,
    Button,
    LinearProgress,
    Typography,
    Grid,
    FormControl,
    CircularProgress,
    Radio,
    RadioGroup,
    FormControlLabel,
    TextField,
    Autocomplete
} from '@mui/material';

import {
    setDataAction,
    getLandlordAction,
    getApartmentAction,
    getRiderAction,
    setLandlordArrayAction,
    setApartmentArrayAction,
    setRiderArrayAction,
    checkPolicyDuplicatedAction,
    setpolicyDuplicatedAction
} from 'redux/actions/getFormActions';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BorderAll } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const Form1 = (props) => {
    const { actions, token, formData, handleNext, handleBack } = props;

    const classes = useStyles();
    const [landlord, setLandlord] = useState(null);
    const [apartment, setApartment] = useState(null);
    const [policy, setPolicy] = useState(null);
    const [landlordArray, setLandlordArray] = useState(null);
    const [apartmentArray, setApartmentArray] = useState(null);
    const [policyArray, setRiderArray] = useState(null);
    const [duplicated, setDuplicated] = useState(null);
    const [riderName, setRiderName] = useState(null);
    const [policyStartDate, setPolicyStartDate] = useState(null);
    const [policyEndDate, setPolicyEndDate] = useState(null);
    const [futurePolicy, setFuturePolicy] = useState(false);
    const [leaseStartDate, setLeaseStartDate] = useState(null);
    const [leaseEndDate, setLeaseEndDate] = useState(null);
    const [leaseDateError, setLeaseDateError] = useState(false);
    const [isCorrectTerm, setIsCorrectTerm] = useState(null);
    const [cities, setCities] = useState([]);
    const [landlordCity, setLandlordCity] = useState(null);
    const [landlordByCity, setLandlordByCity] = useState(null);
    const [policyErrorType, setPolicyErrorType] = useState(0)

    useEffect(() => {
        setLandlordCity(formData.data.city);
        setLandlord(formData.data.landlord);
        setLandlordByCity(formData.data.landlordByCity);
        setApartment(formData.data.apartment);
        setPolicy(formData.data.policy);
        setLandlordArray(formData.landlordArray);
        setApartmentArray(formData.apartmentArray);
        setRiderArray(formData.policyArray);
        setLeaseStartDate(formData.data.leaseStartDate || null);
        setLeaseEndDate(formData.data.leaseEndDate || null);
        setIsCorrectTerm(formData.data.isCorrectTerm);
        setPolicyStartDate(formData.data.policyStartDate);
        setPolicyEndDate(formData.data.policyEndDate);
        if (formData.policyDuplicated) {
            formData.policyDuplicated.length > 0 ? setDuplicated(formData.policyDuplicated[0]) : setDuplicated(null)
        } else {
            setDuplicated(null)
        }
        if (formData.landlordArray && formData.landlordArray.length > 0) {
            let landlord_cities = [];
            for (const landlord of formData.landlordArray) {
                if (!landlord_cities.includes(landlord['BillingCity'])) {
                    landlord_cities.push(landlord['BillingCity'])
                }
                setCities(landlord_cities.sort())
            }
        }

        if (formData.policyArray && formData.policyArray.length > 0 && formData.data.policy) {
            let selectedPolicy = formData.policyArray.filter(item => item.Id === formData.data.policy)[0];
            let gapDays = (new Date() - new Date(selectedPolicy.Lease_End_Date__c)) / 3600000 / 24
            if (gapDays > 120) {
                setPolicyErrorType(1);
            } else {
                setPolicyErrorType(0);
            }
        }


    }, [formData])

    const handleCity = (e) => {
        const city = e.target.value;
        setLandlordCity(city);
        let landlords = [];
        for (const landlord of landlordArray) {
            if (landlord['BillingCity'] === city) {
                landlords.push(landlord)
            }
        }
        setLandlordByCity(landlords);
        actions.setApartmentArrayAction(null);
        actions.setRiderArrayAction(null);
        actions.setpolicyDuplicatedAction(null);
        actions.setDataAction({
            ...formData.data,
            city: city,
            landlord: null,
            apartment: null,
            policy: null,
            landlordByCity: landlords
        });
    }

    const handleLandlord = (event) => {
        setLandlord(event.target.value);
        actions.getRiderAction({
            landlordId: event.target.value,
        });
        actions.getApartmentAction({
            landlordId: event.target.value,
        });
        actions.setApartmentArrayAction(null);
        actions.setRiderArrayAction(null);
        actions.setpolicyDuplicatedAction(null);
        actions.setDataAction({
            ...formData.data,
            landlord: event.target.value,
            apartment: null,
            policy: null
        });
    };

    const handleApartment = (event) => {
        setApartment(event.target.value);
        actions.getRiderAction({
            propertyId: event.target.value,
        });
        actions.setRiderArrayAction(null);
        actions.setpolicyDuplicatedAction(null);
        actions.setDataAction({
            ...formData.data,
            apartment: event.target.value,
            policy: null
        });
    };

    const handlePolicy = (event) => {
        const policyId = event.target.value;
        const policy = policyArray.filter(item => item.Id === policyId);
        setRiderName(policy[0].Rider_ID__c);
        let policy_start_date, policy_end_date;
        if (policy[0].CoverageStartDate__c) {
            policy_start_date = policy[0].CoverageStartDate__c;
        } else {
            policy_start_date = policy[0].Lease_Start_Date__c;
        }
        if (policy[0].CoverageEndDate__c) {
            policy_end_date = policy[0].CoverageEndDate__c;
        } else {
            policy_end_date = policy[0].Lease_End_Date__c;
        }
        if (new Date(policy[0].CoverageStartDate__c) > new Date()) {
            setFuturePolicy(true);
        }
        setPolicyStartDate(policy_start_date);
        setPolicyEndDate(policy_end_date);
        setPolicy(policyId);
        actions.checkPolicyDuplicatedAction(policyId)
        debugger
        actions.setDataAction({
            ...formData.data,
            apartment: policy[0].Apartment_Building__c,
            policy: policyId,
            riderName: policy[0].Rider_ID__c,
            policyStartDate: policy_start_date,
            policyEndDate: policy_end_date
        });
    };

    let open = false;

    const handleLeaseDate = (e, label) => {
        if (e && e['$d'] != 'Invalid Date') {
            const value = new Date(e['$d']).toISOString().slice(0, 10);
            if (label === 'lease_start_date') {
                setLeaseStartDate(value);
                if (leaseEndDate && !open) {
                    handleChangeDate(value, 'lease_start_date');
                }
            } else {
                setLeaseEndDate(value);
                if (!open) {
                    handleChangeDate(value, 'lease_end_date');
                }
            }
        }
    };

    const handleChangeDate = (date_update, label) => {
        let lease_start_date = label === 'lease_start_date' ? date_update : leaseStartDate;
        let lease_end_date = label === 'lease_end_date' ? date_update : leaseEndDate;
        if ((new Date(lease_start_date).getMonth() !== new Date(policyStartDate).getMonth()) || (new Date(lease_start_date).getFullYear() !== new Date(policyStartDate).getFullYear())) {
            setLeaseDateError(true);
        } else if ((new Date(lease_end_date).getMonth() !== new Date(policyEndDate).getMonth()) || (new Date(lease_end_date).getFullYear() !== new Date(policyEndDate).getFullYear())) {
            setLeaseDateError(true);
        }
    }

    const handleRadio = (event) => {
        setIsCorrectTerm(event.target.value)
    }

    const handleNextButton = () => {
        actions.setDataAction({
            ...formData.data,
            isCorrectTerm: isCorrectTerm,
            leaseStartDate,
            leaseEndDate,
        })
        handleNext()
    }

    return (
        <Fragment>
            <Typography variant="h5" gutterBottom color="primary" sx={{ mt: 5 }} align="center">
                Locate Your Community
            </Typography>
            <Grid container justifyContent='center' sx={{ my: 3 }}>
                <Grid item xs={5}>
                    <Typography variant="h6" color="primary" align='center'>Landlord City</Typography>
                </Grid>
                <Grid item xs={5}>
                    <Autocomplete
                        options={cities || []}
                        getOptionLabel={(option) => option || ""}
                        value={landlordCity || null}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                handleCity({ target: { value: newValue } });
                            } else {
                                handleCity({ target: { value: "" } });
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                disabled={!cities.length}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option === value}
                        sx={{
                            '& > div:nth-child(1)': {
                                '& > div:nth-child(2)': {
                                    marginTop: '0px',
                                },
                                '& input': {
                                    padding: '8px 24px 8px 10px !important',
                                }
                            },
                            border: 0
                        }}
                    />
                    {!landlordArray && <LinearProgress />}
                </Grid>
            </Grid>
            <Grid container justifyContent='center' sx={{ my: 3 }}>
                <Grid item xs={5}>
                    <Typography variant="h6" color="primary" align='center'>Landlord</Typography>
                </Grid>
                <Grid item xs={5}>
                    <Autocomplete
                        options={landlordByCity || []}
                        getOptionLabel={(option) => option.Name || ""}
                        value={landlordByCity?.find(item => item.Id === landlord) || null}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                handleLandlord({ target: { value: newValue.Id } });
                            } else {
                                handleLandlord({ target: { value: "" } });
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                disabled={!landlordByCity}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                        sx={{
                            '& > div:nth-child(1)': {
                                '& > div:nth-child(2)': {
                                    marginTop: '0px',
                                },
                                '& input': {
                                    padding: '8px 24px 8px 10px !important',
                                }
                            },
                            border: 0
                        }}
                    />
                    {!landlordByCity && <LinearProgress />}
                </Grid>
            </Grid>
            <Grid container justifyContent='center' sx={{ my: 3 }}>
                <Grid item xs={5}>
                    <Typography variant="h6" color="primary" align='center'>Policy Reference</Typography>
                </Grid>
                <Grid item xs={5}>
                    <Autocomplete
                        options={policyArray || []}
                        getOptionLabel={(option) => option.Rider_ID__c || ""}
                        value={policyArray?.find(item => item.Id === policy) || null}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                handlePolicy({ target: { value: newValue.Id } });
                            } else {
                                handlePolicy({ target: { value: "" } });
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                disabled={!policyArray}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                        sx={{
                            '& > div:nth-child(1)': {
                                '& > div:nth-child(2)': {
                                    marginTop: '0px',
                                },
                                '& input': {
                                    padding: '8px 24px 8px 10px !important',
                                }
                            },
                            border: 0
                        }}
                    />
                    {!policyArray && <LinearProgress />}
                </Grid>
            </Grid>
            {policyStartDate &&
                <Grid container justifyContent='center' sx={{ mt: 3 }}>
                    <Grid item xs={5}>
                        <Typography variant="body1" color="primary" align='left'>
                            PolicyStartDate: {new Date(policyStartDate).getDate() + 1}/{new Date(policyStartDate).getMonth() + 1}/{new Date(policyStartDate).getFullYear()}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="body1" color="primary" align='left'>
                            PolicyEndDate: {new Date(policyEndDate).getDate() + 1}/{new Date(policyEndDate).getMonth() + 1}/{new Date(policyEndDate).getFullYear()}
                        </Typography>
                    </Grid>
                </Grid>
            }
            {policy &&
                <Grid container justifyContent='center' alignItems='center' sx={{ mb: 3 }}>
                    <Grid item xs={4} >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                variant="standard"
                                label="Tenancy Start Date"
                                inputFormat="DD/MM/YYYY"
                                minDate="01/01/2018"
                                value={leaseStartDate}
                                onOpen={() => open = true}
                                onClose={() => open = false}
                                onChange={(e) => setTimeout(() => handleLeaseDate(e, 'lease_start_date'), 100)}
                                renderInput={(params) => <TextField variant="standard" {...params} sx={{ svg: { color: '#702572' } }} />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={4} sx={{ marginLeft: "30px", marginRight: "20px" }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                variant="standard"
                                label="Tenancy End Date"
                                inputFormat="DD/MM/YYYY"
                                minDate="01/01/2018"
                                value={leaseEndDate}
                                onOpen={() => open = true}
                                onClose={() => open = false}
                                onChange={(e) => setTimeout(() => handleLeaseDate(e, 'lease_end_date'), 100)}
                                renderInput={(params) => <TextField variant="standard"  {...params} sx={{ svg: { color: '#702572' } }} />}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
            }
            {formData.policyDuplicated && formData.policyDuplicated.length === 0 && futurePolicy &&
                <Dialog
                    open={futurePolicy}
                    maxWidth="md"
                >
                    <DialogContent>
                        <Typography color="primary" textAlign="center" variant='h4' sx={{ p: 1 }}>The policy period you have selected is a future policy that has not started yet.</Typography>
                        <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>Please select a current policy that matches the current lease dates.</Typography>
                        <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>If you have any questions, please contact <a href={"mailto:claims@leapguaranty.co.uk"} >claims@leapguaranty.co.uk</a></Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' colr="primary" onClick={() => setFuturePolicy(false)}>Ok</Button>
                    </DialogActions>
                </Dialog>
            }

            <Dialog open={policyErrorType === 1} maxWidth="md">
                <DialogContent>
                    <Typography color="primary" textAlign="center" variant='h4' sx={{ p: 1 }}>Oops!</Typography>
                    <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>The current date is greater than 120 days after the policy expiration date
                    </Typography>
                    <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>If you have any questions, please contact <a href={"mailto:claims@leapguaranty.co.uk"} >claims@leapguaranty.co.uk</a></Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' colr="primary" onClick={() => setPolicyErrorType(2)}>Ok</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={leaseDateError}
                maxWidth="md"
            >
                <DialogContent>
                    <Typography color="primary" textAlign="center" variant='h4' sx={{ p: 1 }}>The lease start and end date you have entered is outside the selected policy’s term.</Typography>
                    <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>Are you sure the entered lease term dates are correct?</Typography>
                    <Grid container justifyContent="center">
                        <FormControl>
                            <RadioGroup
                                row
                                value={isCorrectTerm}
                                onChange={handleRadio}
                            >
                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="No" control={<Radio />} label="No" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="center">
                        <Button
                            variant='contained'
                            color="primary"
                            onClick={() => setLeaseDateError(false)}
                            disabled={!isCorrectTerm}
                        >Ok</Button>
                    </Grid>
                </DialogActions>
            </Dialog>
            {duplicated &&
                <Dialog
                    open={!!duplicated}
                    maxWidth="md"
                >
                    <DialogContent>
                        <Typography color="primary" textAlign="center" variant='h4' sx={{ p: 1 }}>Oops!</Typography>
                        <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>It looks like a claim has already been filed on this BinderID.</Typography>
                        <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>Please contact: <a href={"mailto:claims@leapguaranty.co.uk?subject=" + riderName} >claims@leapguaranty.co.uk</a></Typography>
                        <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>BinderID: {riderName}</Typography>
                        <Typography color="primary" textAlign="center" variant='h5' sx={{ p: 1 }}>Claim # {duplicated.Name}</Typography>
                        <Typography color="primary" textAlign="center" variant='h6' >Created Date {new Date(duplicated.CreatedDate).getDate() + 1}/{new Date(duplicated.CreatedDate).getMonth() + 1}/{new Date(duplicated.CreatedDate).getFullYear()}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' colr="primary" onClick={() => setDuplicated(null)}>Ok</Button>
                    </DialogActions>
                </Dialog>
            }
            
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2 }}>
                {(policy && !formData.policyDuplicated) ?
                    <CircularProgress />
                    :
                    <>
                        {policy && formData.policyDuplicated.length === 0 && !(new Date(policyStartDate) > new Date()) &&
                            <Button
                                onClick={() => handleNextButton()}
                                variant="contained"
                                disabled={!(landlord && policy && leaseStartDate && leaseEndDate)}
                            >
                                <Typography variant='body1' >
                                    Next
                                </Typography>
                            </Button>
                        }
                    </>
                }
            </Box>
        </Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({
            setDataAction,
            getLandlordAction,
            getApartmentAction,
            getRiderAction,
            setLandlordArrayAction,
            setApartmentArrayAction,
            setRiderArrayAction,
            checkPolicyDuplicatedAction,
            setpolicyDuplicatedAction
        }, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form1);